import "./App.css";
import TurboCut from "./pages/TurboCut";

function App() {
  return (
    <div className="App">
      <TurboCut />
    </div>
  );
}

export default App;